import angular from 'angular'
import Mailcheck from 'mailcheck'

angular.module("core.application.main").directive("core.application.main.directive.mailcheck", [
    "$compile", "$timeout",
    function($compile, $timeout) {

        // This directive implements this: https://github.com/mailcheck/mailcheck
        // So if the user types test@gnail.com it will suggest test@gmail.com to them

        var expose = {};

        expose.require = "ngModel";
        expose.restrict = "A";

        expose.link = function($scope, element, attributes, controller) {

            var suggestionTemplate;
            $scope.suggestion = "";
            $scope.delaySuggestionTime = 500; // in milliseconds

            // PAYL-5690 expand the library of emails that the mailcheck suggestions will look at
            Mailcheck.defaultTopLevelDomains.push("edu.au", "xyz"); // any "edu.au" was being suggested as "net.au"
            Mailcheck.defaultDomains.push(
                "bigpond.com",
                "bigpond.com.au",
                "bigpond.net.au",
                "gmail.com.au",
                "y7mail.com",
                "iinet.net.au",
                "tpg.com.au",
                "det.nsw.edu.au",
                "westnet.com.au",
                "internode.on.net",
                "iprimus.com.au",
                "adam.com.au",
                "edumail.vic.gov.au",
                "dodo.com.au",
                "eq.edu.au",
                "aapt.net.au",
                "uon.edu.au",
                "my.jcu.edu.au",
                "windowslive.com",
                "uqconnect.edu.au",
                "griffithuni.edu.au",
                "ozemail.com.au",
                "netspace.net.au",
                "gmx.com",
                "mail.com",
                "gap.com"
            );

            suggestionTemplate = $compile("" +
                "<div class='mailcheck-suggestion' ng-show='suggestion'>" +
                    "<span class='text text-error'><span ng-i18next>did-you-mean</span>{{suggestion}}?</span>&nbsp;" +
                    "<a class='link' ng-click='useSuggestion()'><span ng-i18next>general:yes</span></a>" +
                "</div>")($scope);
            element.after(suggestionTemplate);

            element.on("blur keyup", function() {
                $scope.checkForSuggestion();
            });

            $scope.useSuggestion = function() {
                controller.$setViewValue($scope.suggestion);
                controller.$render();
                $scope.suggestion = "";
            };

            $scope.checkForSuggestion = function() {
                $timeout(function() {
                    // Updating the Angular scope from the third party Mailcheck code
                    // can cause "$digest already in progress" errors
                    // so we wrap it in a timeout to force it to run asyncronously
                    // which will stop these errors from occurring
                    var originalEmail = controller.$viewValue;
                    Mailcheck.run({
                        email: originalEmail,
                        suggested: function(suggestion) {
                            $timeout(function() {
                                if (originalEmail === controller.$viewValue) {
                                    // if the user hasn't changed the email address
                                    // after the delay, then assume they are finished typing
                                    // and display the suggestion
                                    $scope.suggestion = suggestion.full;
                                    $scope.$digest();
                                }
                            // PAYL-5673 deliberately delay showing the suggestion
                            // to avoid unnecessary suggestions
                            }, $scope.delaySuggestionTime);
                        },
                        empty: function() {
                            $scope.suggestion = "";
                        }
                    });
                }, 0);
            };

            // we need the suggestion to run when the directive loads
            // So that if the email address is already prefilled with an
            // incorrect email address it can suggest a correct one
            // For example, when clicking from the /login to to the /reset-ask
            // pages in the admin and merchant portals
            $scope.checkForSuggestion();

        };

        return expose;
    }
]);
